import { useMemo } from 'react';

import getVideoId from 'get-video-id';
import { FiHeart, FiPlay } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { VideosData } from '@common/types/api';

import * as S from './styles';

type RelatedVideosProps = {
  videos: VideosData[];
  currentVideoId: number;
};

const RelatedVideos = ({ videos, currentVideoId }: RelatedVideosProps) => {
  const videosWithThumbnails = useMemo(
    () =>
      videos.map((video) => {
        const { id, service } = getVideoId(video.url_video);
        const thumbnail =
          service === 'youtube' && id
            ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg`
            : video.url_image;
        return { ...video, thumbnail };
      }),
    [videos],
  );

  return (
    <S.Container>
      <S.Header>
        <h3>
          Outros Vídeos
          <S.VideoCount>{videos.length}</S.VideoCount>
        </h3>
      </S.Header>
      {videosWithThumbnails.map((video) => (
        <Link to={`/videos/${video.id}`} key={video.id}>
          <S.VideoItem $playing={video.id === currentVideoId}>
            <S.Thumbnail>
              <img src={video.thumbnail} alt={video.title} />
              {video.id !== currentVideoId && (
                <S.ThumbnailPlayOverlay>
                  <FiPlay />
                </S.ThumbnailPlayOverlay>
              )}
            </S.Thumbnail>
            <S.VideoInfo>
              <S.VideoTitle>{video.title}</S.VideoTitle>
              <S.VideoMeta>
                <FiHeart size="0.6875rem" />
                {video.likes_count} curtidas
              </S.VideoMeta>
            </S.VideoInfo>
          </S.VideoItem>
        </Link>
      ))}
    </S.Container>
  );
};

export default RelatedVideos;
